/**
 * RpgFaqPage (ТЗ №5 §12) — a static Q&A explaining the Mini-RPG economy and mechanics:
 * мора / примогемы, обмен и его лимиты, оружие, прокачка, мобы и боссы, алхимия, переводы.
 * Static copy only — no data fetching.
 */
import { useBackButton } from "@melusine/shared-telegram";
import { routes, useNavigate } from "@shared/router";

import { RpgHeader } from "./ui/RpgHeader";
import styles from "./rpg.module.css";

interface QA {
  readonly q: string;
  readonly a: string;
}

const FAQ: readonly QA[] = [
  {
    q: "Что такое мора?",
    a: "Мора — основная игровая валюта Mini-RPG. Её зарабатывают в боях с мобами и боссами и тратят на прокачку героя, улучшение оружия, алхимию и покупки в игровом магазине.",
  },
  {
    q: "Что такое примогемы?",
    a: "Примогемы — премиальная валюта. Их можно получить обменом моры и использовать как скидку при покупках в основном магазине (с лимитом списания на товар).",
  },
  {
    q: "Как обменять мору на примогемы?",
    a: "Откройте раздел «Обмен», выберите готовую сумму или введите количество моры (кратное курсу). Курс по умолчанию — 10 моры за 1 примогем; точный курс показан на экране и считается на сервере.",
  },
  {
    q: "Есть ли лимит на примогемы?",
    a: "Списание примогемов при оплате товаров ограничено: для каждого товара админ задаёт максимум примогемов, которыми можно частично оплатить покупку. Сам обмен моры на примогемы лимита не имеет, кроме вашего баланса моры.",
  },
  {
    q: "Как работает оружие?",
    a: "В разделе «Развитие → Оружие» показан каталог. Полученное оружие можно экипировать (оно повышает итоговый урон) и улучшать за мору и материалы — каждый уровень увеличивает урон.",
  },
  {
    q: "Как прокачивать героя?",
    a: "Во вкладке «Прокачка» можно повысить здоровье и урон за мору. Также герой получает уровни и ранги за опыт в боях — с ростом ранга открываются новые мобы, рецепты и товары.",
  },
  {
    q: "Как сражаться с мобами?",
    a: "В разделе «Бой» выберите противника. У каждого моба есть уровень, здоровье, урон, шанс победы и награда. Часть мобов требует определённого ранга, имеет дневной лимит попыток или перезарядку — это указано в карточке.",
  },
  {
    q: "Чем боссы отличаются от обычных мобов?",
    a: "Боссы сильнее, дают больше моры и опыта и имеют шанс редкого дропа материалов. Обычно для них нужен более высокий ранг, а попытки ограничены лимитом или перезарядкой.",
  },
  {
    q: "Что такое алхимия?",
    a: "В разделе «Алхимия» по рецептам создаются предметы и материалы. Для крафта нужны входные материалы (из боёв) и иногда мора; некоторые рецепты открываются с ростом ранга.",
  },
  {
    q: "Как переводить валюту другим игрокам?",
    a: "В разделе «Переводы» укажите получателя (@username или Telegram ID), валюту (мора или примогемы) и сумму. Перед отправкой появится подтверждение. Перевод нельзя отправить самому себе, а сумма не может превышать ваш баланс.",
  },
];

export function RpgFaqPage(): JSX.Element {
  const navigate = useNavigate();

  useBackButton(() => {
    navigate(routes.rpg());
  });

  return (
    <div className={styles.page}>
      <RpgHeader title="FAQ" onBack={() => navigate(routes.rpg())} />
      <div className={styles.faqList}>
        {FAQ.map((item) => (
          <div key={item.q} className={styles.faqItem}>
            <div className={styles.faqQ}>{item.q}</div>
            <div className={styles.faqA}>{item.a}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
